import styled from 'styled-components'

export const BookmarkToggleComponent = styled.div`
  display: inline-block;
  background: ${ (props) => props.theme.colors['hintergrund-prio3'] };
  border-top-left-radius: 22px;
  border-bottom-left-radius: 22px;
  transition: width 0.2s ease-out;
  overflow: hidden;
  width: 45px;
  white-space: nowrap;

  &:hover {
    width: ${ (props) => (props.isBookmarked ? '151px' : '112px') };

    @media ${ (props) => props.theme.breakpoints.devices.min.lg }, print {
      width: ${ (props) => (props.isBookmarked ? '163px' : '119px') };
    }
  }

  // css overwrite (mode the bookmark will not render at header)
  &.mobile-toggle {
    position: absolute;
    right: 0;
    top: 5px;
    z-index: 1;
  }
`

export const BookmarkToggleButton = styled.button`
  padding: 10px 15px 10px 5px;
  border: 0;
  background: transparent;
  font-weight: 200;
  cursor: '${ (props) => (!props.disabled ? 'pointer' : 'inherit') }';
  display: flex;
  align-items: center;

  .bookmark-text {
    color: ${ (props) => props.theme.colors['icon-grau-0'] };
  }

  &::before {
    color: ${ (props) => props.theme.colors.grau2 };
    padding: 0 8px;
    display: inline-block;
    font: normal normal normal 14.54545px 'aok-icons-functional';
    font-size: 24px !important;
    line-height: 1;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    transform: translate(0, 0);
    content: '${ (props) => (props.isBookmarked ? '' : '') }';
    vertical-align: middle;
  }

  &:focus {
    outline: 0;
  }
`
